import { SFC } from "react";
import * as React from "react";
import './Footer.scss'

const Footer: SFC = () => {
  return (
    <section className='reska-footer'>
      <div className='row'>
        <div className='col'>
          <footer className='reska-footer-content reska-footer-content-item'>
            <ul>
              <li>
                <a
                  href='https://s3-ap-northeast-1.amazonaws.com/marespera-corporate-site/privacy-policy/PrivacyPolicy.pdf'
                  target='_blank'
                  rel="noopener noreferrer"
                >
                  <small>プライバシーポリシー</small>
                </a>
              </li>
              <li>
                <a
                  href='https://s3-ap-northeast-1.amazonaws.com/marespera-corporate-site/terms-of-service/TermsOfService.pdf'
                  target='_blank'
                  rel="noopener noreferrer"
                >
                  <small>利用規約</small>
                </a>
              </li>
              <li>
                <a href='https://marespera.co.jp' target='_blank' rel="noopener noreferrer">
                  <small>運営会社</small>
                </a>
              </li>
            </ul>
          </footer>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <div className='reska-footer-content reska-footer-content-copyright'>
            <small>Copyright© All right reserved MareSpera Inc.</small>
          </div>
        </div>
      </div>
    </section>
  )
};

export default Footer;
